export var TransactionEnum;
(function (TransactionEnum) {
    TransactionEnum["TRANSFER"] = "Transfer";
    TransactionEnum["CROSS_CHAIN_TRANSFER"] = "CrossChainTransfer";
    TransactionEnum["CLAIM_TOKEN"] = "ClaimToken";
    TransactionEnum["TRANSFER_RED_PACKET"] = "TransferRedPacket";
    TransactionEnum["CROSS_CHAIN_RECEIVE"] = "ReleaseToken";
    TransactionEnum["SWAP"] = "SwapExactTokensForTokens";
})(TransactionEnum || (TransactionEnum = {}));
